import React from "react";

const variants = {
  success: { background: "var(--grn-d)", border: "1px solid var(--grn)", color: "var(--grn)" },
  error: { background: "var(--red-d)", border: "1px solid var(--red)", color: "var(--red)" },
  warn: { background: "var(--gdim)", border: "1px solid var(--gold)", color: "var(--gold)" },
  info: { background: "var(--blu-d)", border: "1px solid var(--blu)", color: "var(--blu)" },
};

export default function Alert({ children, variant = "info", style = {}, ...props }) {
  const v = variants[variant] || variants.info;
  return (
    <div
      role="alert"
      style={{
        padding: "var(--sp-3) var(--sp-4)",
        borderRadius: "var(--sp-2)",
        fontSize: 13,
        fontFamily: "'Outfit', sans-serif",
        ...v,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
